import * as React from "react";
import { PageWrapper } from "../../../components/PageWrapper";
import { VideoScriptsTable } from "./components/VideoScriptsTable";

export const VideoScriptsPage: React.FC = () => {
  React.useEffect(() => {
    window.onpageshow = function (event) {
      if (event.persisted) {
        window.location.reload();
      }
    };
  }, []);

  return (
    <PageWrapper title={"Video Scripts"} hideSeparator={true}>
      <VideoScriptsTable />
    </PageWrapper>
  );
};
